/* src/contexts/profile/profileActionsCST.js */
import { useCallback } from 'react';
import { doc, updateDoc, serverTimestamp, arrayUnion, increment } from 'firebase/firestore';
import { db as firestoreDb } from '../../firebaseConfig';

/**
 * Hook creator for Add CST Result action.
 */
export const useCreateAddCstResultAction = (
    authUserRef,
    setError
) => {
    return useCallback(async (profileId, resultData) => {
        const currentUserId = authUserRef.current?.uid;
        if (!currentUserId || !profileId || !resultData) {
            setError("Missing data for CST result.");
            return false;
        }
        setError(null);
        const db = firestoreDb;
        const profileRef = doc(db, 'users', currentUserId, 'profiles', profileId);
        try {
            const payload = {
                ...resultData,
                timestamp: serverTimestamp(),
            };
            await updateDoc(profileRef, {
                cstHistory: arrayUnion(payload),
                ...(resultData.familiarizationSession
                    ? { cstFamiliarizationCount: increment(1) }
                    : { lastCstAssessmentTimestamp: serverTimestamp() }
                ),
                updatedAt: serverTimestamp()
            });
            // Listener will update cstHistory in local state (via activeProfileData)
            return true;
        } catch (err) {
            console.error("Error adding CST result:", err);
            setError("Failed to save CST result.");
            return false;
        }
    }, [authUserRef, setError]);
};